<template>
  <div>
    <div class="founding" v-if="isMobile == 'pc'">
      <div class="founding-top">
        <div class="founding-img">
          <div class="founding-img-title">
            <h2>{{ $t('Council') }}</h2>
          </div>
          <div class="top-list" v-for="item in councilList" :key="item.id">
            <div style="display: flex;align-items: center;">
              <div style="width:12.5%;">
                <img :src="item.imgUrl" alt="" style="width: 100%;height: 100%;">
              </div>
              <div style="margin-left:3rem;">
                <sapn style="font-size: 1.3rem;font-weight: 500;">{{ item.title }}</sapn>
                <div style="margin-top: 1rem;">
                  <span style="font-size: 0.9rem;position: relative;top: -0.5rem;">{{ item.digest }}</span>
                </div>
              </div>
            </div>
            <div style="margin-top: 0.6rem;font-size:0.8rem;line-height:1.5rem;" v-html="item.content">
            </div>
          </div>
        </div>
      </div>
      <div class="founding-img">
        <div class="founding-img-title">
          <h2>{{$t('CouncilMember')}}</h2>
        </div>
        <div class="founding-img-list">
          <el-row :gutter="40">
            <el-col :span="screenWidth<=540?12:6" v-for="item in councilUserList" :key="item">
              <div class="founding-img-list-item">
                <img :src="item.imgUrl" alt="" style="width: 100%;">
                <div class="founding-img-list-name">{{ item.title }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    

    <!-- 移动端 -->
    <div class="founding-mobile" v-if="isMobile == 'mobile'">
      <div class="lishi or" v-for="item in councilList" :key="item.id">
        <div class="lishi-top or">
          <div class="pic">
            <img :src="item.imgUrl" alt="">
          </div>
          <ul class="lishi-content">
            <li class="lishi-content-title">
              <h1>{{ item.title }}</h1>
            </li>
            <li>{{ item.digest }}</li>
          </ul>
        </div>
        <!-- <p class="content">{{ item.content }}</p> -->
		<div class="content" v-html="item.content"></div>
        <!-- <span>
          <img :src="item.extId" alt="">
        </span> -->
      </div>

      <div class="lishidi or">
        <div class="title or">
          <h1>{{$t('CouncilMember')}}</h1>
        </div>
        <div class="con or">
          <div class="con-box" v-for="item in councilUserList" :key="item">
            <div class="con-box-img">
              <img :src="item.imgUrl" alt="">
            </div>
            <div style="text-align:center;">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import { mapState } from 'vuex'
import { listInfo } from '@/api/index';
export default {
  computed: {
    ...mapState(['screenWidth']),
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        for (let i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > -1) {
                return 'mobile'; // 移动端
            }
        }
        return 'pc'; // PC端
    }
  },
  data() {
    return {
      councilUserList: [],
      councilList: []
    };
  },
  mounted() {
	  //理事会
	this.listCouncil();
	//理事会成员
	this.listCouncilMember()
  },
  methods: {
	  //理事会
	 listCouncil() {
		 const formData = new FormData();
		 formData.append("moduleId", 11);
		 listInfo(formData).then(res => {
		   if (res.data && res.data != null) {
		     this.councilList = res.data;
		   }
		 })
	  },
	  //理事会成员
	  listCouncilMember() {
	  		 const formData = new FormData();
	  		 formData.append("moduleId", 21);
	  		 listInfo(formData).then(res => {
	  		   if (res.data && res.data != null) {
	  		     this.councilUserList = res.data;
	  		   }
	  		 })
	   },
  }
};
</script>

<style lang="less" scoped>
.founding {
  margin-top: -2rem;
  .founding-img {
    margin: 0 auto;
    width: 80%;
    .founding-img-title {
      margin-top: 5rem;
      text-align: center;
    }
    .founding-img-list {
      margin-top: 3rem;
      background-color: white;
      padding: 2rem;
      padding-bottom: 1rem;
      .founding-img-list-item {
        width: 100%;
        height: 12rem;
        box-sizing: border-box;
        border-radius: 0.3rem;
        // margin-top: 2rem;
        font-size: 1rem;
        text-align: center;
        .founding-img-list-name {
        	height: 4rem;
          // line-height: 1.3rem;
          padding-top: 0.5rem;
        }
      }
    }
  }
}
.top-list {
  background-color: #fff;
  margin-top: 2rem;
  padding: 1rem;
  box-sizing: border-box;
  box-shadow: 0 0 1rem #f8f8f8;
}


.founding-mobile {
  margin: 0 auto;
  max-width: 100%;
  .lishi{
    // width: 24rem;
    margin: 0 auto;
    margin-top: 1rem;
    border-bottom: 1px solid #d0d0d0;
    padding: 0 1.5rem 1.2rem 1.5rem;
    .lishi-top{
      // display: flex;
      // align-items: center;
      .pic{
        width: 8.35rem;
        float: left;
        img{
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .lishi-content{
        width: 16rem;
        // float: right;
        float: left;
        font-size: 0.6rem;
        margin-left: 2rem;
        .lishi-content-title{
          h1{
            font-weight: normal;
            font-size: .9rem;
            margin: 3rem 0 .5rem 0;
          }
        }
      }
    }
    
    
    .content{
      font-size: 0.6rem;
      line-height: 0.95rem;
      color: #666;
      margin-top: 1rem;
    }
    span{
      width: 3.3rem;
      float: right;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
  .lishidi{
    width: 28.8rem;
    margin: 0 auto;
    overflow: hidden;
    h1{
      font-size: .9rem;
      margin: 2rem auto 1rem auto;
      text-align:center;
    }
    .con{
      .con-box{
        width: 6.43rem;
        height: 5.25rem;
        float: left;
        font-size: .6rem;
        line-height: .7rem;
        margin: .5rem 0.38rem;
        .con-box-img{
          margin-bottom: .5rem;
          img{
            width: 100%;
          }
        }
      }
    }
  }
}
.or{
  overflow: hidden;
}
</style>